import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AttributeType } from 'src/app/interfaces/product-details';
import { ProductDetailsService } from 'src/app/services/product-details.service';

@Component({
  selector: 'app-upload-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class UploadProductDetailsComponent implements OnInit, OnDestroy {
  csvColumns: string[] = [];
  filteredCsvColumns: string[] = [];
  csvRows: any[] = [];
  filteredCsvRows: any[] = [];
  categories: string = '';
  clusterEnhanced: boolean = false;

  identifiers: string[] = ['EAN', 'UPC', 'ASIN', 'AID'];

  productIdColumnIndex: number | null = null;
  selectedIdentifier: string | null = null;
  identifierColumnIndex: number | null = null;

  CUSTOM_IDENTIFIER_TYPE: string = '';

  languages: string[] = [
    'English (United States)',
    'English (Canada)',
    'Portuguese',
    'Spanish (Mexico)',
    'English (United Kingdom)',
    'German',
    'French',
    'Spanish (Spain)',
    'French (Belgium)',
    'Dutch (Netherlands)',
    'Italian',
    'Swedish',
    'Polish',
    'Arabic (Egypt)',
    'Turkish ',
    'Arabic (Saudi Arabia)',
    'Arabic (United Arab Emirates)',
    'English (India)',
    'Japanese',
    'English (Australia)',
    'English (Singapore)'
  ];
  selectedLanguage: string = this.languages[0];

  outputFileFormats: string[] = ['CSV', 'JSON'];
  selectedOutputFileFormat: string = this.outputFileFormats[0];

  attributeTypes: { name: AttributeType, title: string }[] = [
    {
      name: 'core',
      title: 'Core Attributes',
    },
    {
      name: 'all',
      title: 'All Attributes',
    },
    {
      name: 'all_with_columns',
      title: 'All Attributes as Columns',
    }
  ];
  selectedAttributeType: AttributeType = 'core';

  additionalAttributes: string = '';

  reportsFileDataChangedSubscription!: Subscription;

  constructor(
    private productDetailsService: ProductDetailsService,
    public modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.reportsFileDataChangedSubscription = this.productDetailsService.watchChanges.subscribe(() => {
      this.csvColumns = this.productDetailsService.fileColumns;
      this.csvRows = this.productDetailsService.fileRows;

      this.CUSTOM_IDENTIFIER_TYPE = this.productDetailsService.CUSTOM_IDENTIFIER_TYPE;

      this.filterTablePreview();
    });
  }

  ngOnDestroy() {
    this.reportsFileDataChangedSubscription.unsubscribe();
  }

  onNextHandler = () => {
    this.productDetailsService.productIdColumnIndex = this.productIdColumnIndex;
    this.productDetailsService.selectedIdentifier = this.selectedIdentifier;
    this.productDetailsService.identifierColumnIndex = this.identifierColumnIndex;
  };

  changeIdentifier = (identifier: string) => {
    this.onNextHandler();

    if (identifier === null || identifier !== this.CUSTOM_IDENTIFIER_TYPE) {
      this.identifierColumnIndex = null;
    }
    this.productDetailsService.selectedIdentifier = this.selectedIdentifier;
  };

  filterColumn = (column_index: number) => {
    if (this.productIdColumnIndex !== null || this.productIdColumnIndex !== null) {
      if (column_index === this.productIdColumnIndex || column_index === this.identifierColumnIndex) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  };

  filterTablePreview = () => {
    this.onNextHandler();

    if (this.productIdColumnIndex !== null || this.productIdColumnIndex !== null) {
      this.filteredCsvColumns = [...this.csvColumns.filter((column, index) => {
        return this.productIdColumnIndex === index || this.identifierColumnIndex === index;
      })];
      this.filteredCsvRows = [...this.csvRows.filter((column, index) => {
        return this.productIdColumnIndex === index || this.identifierColumnIndex === index;
      })];
    } else {
      this.filteredCsvColumns = [...this.csvColumns];
      this.filteredCsvRows = [...this.csvRows];
    }
  };

  canGenerateReport = (): boolean => {
    if (
      this.productIdColumnIndex !== null &&
      this.selectedIdentifier !== null &&
      (this.selectedIdentifier !== this.CUSTOM_IDENTIFIER_TYPE || (this.selectedIdentifier === this.CUSTOM_IDENTIFIER_TYPE && this.identifierColumnIndex !== null))
    ) {
      return true;
    }
    return false;
  };

  additionalAttributesChanged(attributes: string) {
    this.additionalAttributes = attributes;
  }

  getReportRequestParams(): Record<string, string> {
    const params: Record<string, string> = {
      language: this.selectedLanguage,
      outputDataType: this.selectedOutputFileFormat,
      clusterEnhanced: this.clusterEnhanced.toString()
    };
    if (this.selectedIdentifier !== null && this.selectedIdentifier !== this.CUSTOM_IDENTIFIER_TYPE) {
      params['identifiersType'] = this.selectedIdentifier;
    }
    let reportParameters: string = 'attributes,' + (this.selectedAttributeType === 'all_with_columns' ? 'all' : this.selectedAttributeType);
    if (this.selectedAttributeType === 'all_with_columns') {
      reportParameters += ',showAllAttr,true';
    } else if (this.selectedAttributeType === 'all' && this.additionalAttributes) {
      reportParameters += ',addnlCore,' + this.additionalAttributes + ',showAllAttr,false';
    }
    params['reportParameters'] = reportParameters;
    params['reportParameters'] = reportParameters;
    return params;
  }

}
